import styled from 'styled-components';

export const StyledStatusPicker = styled.div`
    border: 1px solid #E4E7EC;
    border-radius: 12px;
    padding: 10px;
    margin: 10px 0;

    .status-buttons {
        display: flex;
        gap: 10px;
    }

    .status-button {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 6px;
        padding: 14px 0;
        border-radius: 12px;
        border: 1px solid #F4F5F8;
        background: #F4F5F8;
        font-weight: 600;
        font-size: 14px;
        color: #101828;

        img { width: 24px; height: 24px; }
    }

    .status-button.nok.selected {
        border-color: #F43030;
        background: #FDF0F0;
    }

    .status-button.reworked.selected {
        border-color: #F5B900;
        background: #FFFBEB;
    }

    .status-button.hasErrors {
        border-color: #F43030;
    }

    .defect-row {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-top: 10px;
    }

    .defect-row .select-wrap {
        position: relative;
        flex: 1;

        img.down {
            position: absolute;
            right: 12px;
            top: 50%;
            transform: translateY(-50%);
        }
    }

    .add-defect {
        margin-top: 10px;
        width: 100%;
        border: 1px dashed #C7CDD6;
        border-radius: 12px;
        background: transparent;
        color: #0085FF;
        font-weight: 600;
        font-size: 14px;
        padding: 12px 0;
    }
`;

export const StyledNokBox = styled.div`
    border: 1px solid #E4E7EC;
    border-radius: 12px;
    padding: 10px;
    margin: 10px 0;

    .box-header {
        display: flex;
        align-items: center;
        gap: 10px;
    }

    .nok-chip {
        flex: 1;
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 12px;
        border-radius: 12px;
        background: #F4F5F8;
        font-weight: 600;
        font-size: 14px;
        color: #101828;

        img { width: 20px; height: 20px; }
    }

    .stepper {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 6px;
        padding: 6px 10px;
        border-radius: 12px;
        background: #F4F5F8;

        button {
            width: 28px;
            height: 28px;
            border-radius: 50%;
            border: 1px solid #0085FF;
            background: transparent;
            color: #0085FF;
            font-size: 18px;
            line-height: 1;
        }

        button:disabled { opacity: 0.4; }

        input {
            width: 60px;
            border: none;
            background: transparent;
            text-align: center;
            font-weight: 700;
            font-size: 16px;
            color: #101828;
        }

        input.hasErrors { color: #F43030; }
    }

    .defect-row {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-top: 10px;
    }

    .defect-row .select-wrap {
        position: relative;
        flex: 1;

        img.down {
            position: absolute;
            right: 12px;
            top: 50%;
            transform: translateY(-50%);
        }
    }

    .add-defect {
        margin-top: 10px;
        width: 100%;
        border: 1px dashed #C7CDD6;
        border-radius: 12px;
        background: transparent;
        color: #0085FF;
        font-weight: 600;
        font-size: 14px;
        padding: 12px 0;
    }

    .reworked-row {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-top: 10px;
        border: 1px solid #E4E7EC;
        border-radius: 12px;
        padding: 6px 10px;

        .label {
            flex: 1;
            display: flex;
            align-items: center;
            gap: 8px;
            font-weight: 600;
            font-size: 14px;
            color: #101828;

            img { width: 20px; height: 20px; }
        }

        .stepper { flex: 1; background: transparent; padding: 0; }
    }
`;

export const StyledRowSummary = styled.div`
    margin: 12px 0;

    .total {
        display: flex;
        justify-content: center;
        gap: 8px;
        background: #F4F5F8;
        border-radius: 12px;
        padding: 10px;
        font-size: 14px;
        color: #101828;

        b { font-weight: 700; }
    }

    .tiles {
        display: flex;
        gap: 8px;
        margin-top: 8px;
    }

    .tile {
        flex: 1;
        background: #F4F5F8;
        border-radius: 12px;
        padding: 8px 0;
        text-align: center;
        font-size: 12px;
        color: #101828;

        .value { display: block; font-size: 16px; font-weight: 700; margin-top: 2px; }
        &.ok .value { color: #2DD36F; }
        &.reworked .value { color: #F5B900; }
        &.notrew .value { color: #F43030; }
    }
`;

export const StyledSingleComponentsList = styled.div`
    .component-card {
        border: 1px solid #E4E7EC;
        border-radius: 12px;
        padding: 12px;
        margin-bottom: 12px;
    }

    .card-header {
        display: flex;
        align-items: center;
        gap: 8px;

        .number {
            flex: 1;
            font-weight: 600;
            font-size: 14px;
            color: #101828;
            word-break: break-all;
        }
    }

    .status-badge {
        border-radius: 8px;
        padding: 3px 10px;
        font-size: 12px;
        font-weight: 700;
        color: #FFFFFF;

        &.ok { background: #2DD36F; }
        &.nok { background: #F43030; }
        &.reworked { background: #F5B900; }
    }

    .defect-line {
        display: flex;
        align-items: center;
        gap: 6px;
        margin-top: 8px;
        font-size: 13px;
        color: #101828;

        img { width: 14px; height: 18px; }
    }

    .indicator-icons {
        display: flex;
        gap: 4px;
    }

    .card-actions {
        display: flex;
        gap: 10px;
        margin-top: 12px;

        button {
            flex: 1;
            border-radius: 10px;
            padding: 10px 0;
            font-weight: 600;
            font-size: 14px;
            border: none;
        }

        .edit { background: #EAF4FF; color: #0085FF; }
        .delete { background: #FDECEC; color: #F43030; }
    }
`;
